import { Controller, LiveTableView, LivetableWidget } from "@gaming/srvg-classes-core";

// uses srvg.eventExchange

export class LiveTableController extends Controller {
    public name: string;
    button: any;
    _$button: any;
    liveTableApi: LiveTableView;
    liveTableWidget: LivetableWidget;

    constructor(options) {
        options = options || {};
        super( options );

        this.name = 'liveTableController';

        // public options
        this.button = options.button || '#livetable_button';

        this._$button = $(this.button);
        this.liveTableApi = options.liveTable || {};
        this.liveTableWidget = options.liveTableWidget || {};

        // initial call
        //
        if (typeof this.liveTableApi.toggleTable === 'function') {
            var that = this;
            this._$button.click(function () {
                that.liveTableApi.toggleTable($(this));
            });
        }
    }

    handleGuiSwitchEvent(event, provider) {
        this.liveTableApi.setDimensions();
        // switch on/off table

        this.liveTableWidget.destroyWidget(this.liveTableWidget.widgetName, this.liveTableWidget.selector);
        this.liveTableWidget.widgetOptions = this.liveTableWidget.specificViewOptions[event.viewAfter];
        this.liveTableWidget.addLivetable();

        //for ie, try
        // this.liveTableWidget.api.relayout();
    }

    /**
     *
     * @param [data] - data.dimension contains height and width dimension of the current window
     */
    handleWindowResizeEvent(data) {
        // data includes the changed dimension of the whole wrapper
        // but video wrapper is needed, so data will be not used here.
        this.liveTableApi.setDimensions();
    }

    /**
     *
     * @param [data] - data.dimension contains height and width dimension of the current window
     */
    handleRelayoutEvent(data) {
        // data includes the changed dimension of the whole wrapper
        // but video wrapper is needed, so data will be not used here.
        this.liveTableWidget.relayoutLivetable();
    }

}